module.exports = __webpack_public_path__ + "img/avatar.3a0e1f5c.png";